const list = {
    search: [
        {
            showField: "开始时间",
            entityField: "start",
            fieldType: "date",
           
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
        },
        {
            showField: "结束时间",
            entityField: "end",
            fieldType: "date",
           
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
        },
        {
            showField: "单位名称",
            entityField: "unitName",
            fieldType: "string",
            formatterContent:null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
        },
        {
            showField: "申请人名称",
            entityField: "opmName",
            fieldType: "string",
            formatterContent:null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
        },
       

    ],
    hisSearch: [
        {
            showField: "开始时间",
            entityField: "start",
            fieldType: "date",
           
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
        },
        {
            showField: "结束时间",
            entityField: "end",
            fieldType: "date",
           
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
        },
        {
            showField: "资质编号",
            entityField: "quaCode",
            fieldType: "string",
            formatterContent:null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
        },
        {
            showField: "单位名称",
            entityField: "unitName",
            fieldType: "string",
            formatterContent:null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
        },
        {
            showField: "类型",
            entityField: "quaType",
            fieldType: "formatter",
            formatterContent:JSON.stringify([{key:"上游",value:0},{key:"下游",value:1}]),
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
        },
        {
            showField: "申请人",
            entityField: "opmName",
            fieldType: "string",
            formatterContent:null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
        },
      

    ],
    list: [
        {
            showField: "单位名称",
            entityField: "unitName",
            fieldType: "string",
            fieldWeight: 110,
        },
        {
            showField: "类型",
            entityField: "quaType",
            fieldType: "formatter",
            formatterContent: JSON.stringify([
                {
                    key: "下游",
                    value: 1
                },
                {
                    key: "上游",
                    value: 0
                },
            ]),
            fieldWeight: 110,
        },
        {
            showField: "状态",
            entityField: "quaState",
            fieldType: "formatter",
            formatterContent: JSON.stringify([
                {
                    key: "驳回",
                    value: -1
                },
                {
                    key: "初始",
                    value: 0
                },
                {
                    key: "已提交",
                    value: 1
                },
                {
                    key: "已审核",
                    value: 2
                },
                {
                    key: "作废",
                    value: 3
                },
            ]),
            fieldWeight: 110,
        },
        {
            showField: "申请人名称",
            entityField: "createrName",
            fieldType: "string",
            fieldWeight: 100,
        },
        {
            showField: "创建时间",
            entityField: "createTime",
            fieldType: "date",
            fieldWeight: 100,
        },
        {
            showField: "备注",
            entityField: "remark",
            fieldType: "string",
            fieldWeight: 100,
        },
      
    ],
    hisList: [
        {
            showField: "单位名称",
            entityField: "unitName",
            fieldType: "string",
            fieldWeight: 110,
        },
        {
            showField: "类型",
            entityField: "quaType",
            fieldType: "formatter",
            formatterContent: JSON.stringify([
                {
                    key: "下游",
                    value: 1
                },
                {
                    key: "上游",
                    value: 0
                },
            ]),
            fieldWeight: 110,
        },
        {
            showField: "资质编号",
            entityField: "quaCode",
            fieldType: "string",
            fieldWeight: 110,
        },
        {
            showField: "状态",
            entityField: "quaState",
            fieldType: "formatter",
            formatterContent: JSON.stringify([
                {
                    key: "驳回",
                    value: -1
                },
                {
                    key: "初始",
                    value: 0
                },
                {
                    key: "已提交",
                    value: 1
                },
                {
                    key: "已审核",
                    value: 2
                },
                {
                    key: "作废",
                    value: 3
                },
            ]),
            fieldWeight: 110,
        },
        {
            showField: "申请人名称",
            entityField: "createrName",
            fieldType: "string",
            fieldWeight: 100,
        },
        {
            showField: "创建时间",
            entityField: "createTime",
            fieldType: "date",
            fieldWeight: 100,
        },
        {
            showField: "审核人名称",
            entityField: "auditUserName",
            fieldType: "string",
            fieldWeight: 100,
        },
        {
            showField: "审核时间",
            entityField: "auditTime",
            fieldType: "date",
            fieldWeight: 100,
        },
        {
            showField: "备注",
            entityField: "remark",
            fieldType: "string",
            fieldWeight: 100,
        },
      
    ],
    from: {
        //单位类型列表
        typelist: [
            {
                showField: "单位类型",
                entityField: "diName",
                fieldType: "input",
                fieldWeight: 150,
            },
        ],
        //客户列表
        buyerlist: [
            {
                showField: "客户名称",
                entityField: "cmName",
                fieldType: "search",
                searchId: 157783642640384,
                setField: "cmName,cmId,cmCode",
                fieldWeight: 150,
            },
            {
                showField: "客户编号",
                entityField: "cmCode",
                fieldType: "string",
                fieldWeight: 120,
            },

        ],
        //区域列表
        regionlist: [
            {
                showField: "区域名称",
                entityField: "regionName",
                fieldType: "input",
                fieldWeight: 150,
            },
        ],
        //商品列表
        productlist: [
            {
                showField: "通用名称",
                entityField: "bgmName",
                fieldType: "search",
                searchId: 853533363572736,
                setField: "bgmName,bgmId,bgmCode,spec,manufacturer,placeorigin,packingSpec,bgpUnitmeasurement",
                fieldWeight: 200,
            },
            {
                showField: "商品编号",
                entityField: "bgmCode",
                fieldType: "string",
                fieldWeight: 150,
            },
            {
                showField: "规格",
                entityField: "spec",
                fieldType: "string",
                fieldWeight: 120,
            },
            {
                showField: "生产厂商",
                entityField: "manufacturer",
                fieldType: "string",
                fieldWeight: 160,
            },
            {
                showField: "产地",
                entityField: "placeorigin",
                fieldType: "string",
                fieldWeight: 90,
            },
            {
                showField: "装箱规格",
                entityField: "packingSpec",
                fieldType: "string",
                fieldWeight: 120,
            },
            {
                showField: "包装单位",
                entityField: "bgpUnitmeasurement",
                fieldType: "string",
                fieldWeight: 120,
            },
        ],
    }
}
export default list
